const getItemTotals = ({ item, isEarlyPricing }) => {
  const currentPrice = isEarlyPricing ? item.advancedPrice : item.floorPrice;
  const originalPrice = item.floorPrice;

  return { currentPrice, originalPrice };
};

export default getItemTotals;
